import { Suspense } from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import ErrorBoundary from "./shared/components/ErrorBoundary.jsx";
import PublicRoutes from "./portals/public/routes.jsx";
import AdminRoutes from "./portals/admin/routes.jsx";
import OwnerRoutes from "./portals/owner/routes.jsx";
import StaffRoutes from "./portals/staff/routes.jsx";

function LoadingSkeleton() {
  return (
    <div className="min-h-screen bg-slate-50 animate-pulse">
      <div className="h-14 bg-slate-200/60" />
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-4">
        <div className="h-8 w-48 bg-slate-200/80 rounded" />
        <div className="h-4 w-72 bg-slate-200/60 rounded" />
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
          <div className="h-28 bg-slate-200/60 rounded-xl" />
          <div className="h-28 bg-slate-200/60 rounded-xl" />
          <div className="h-28 bg-slate-200/60 rounded-xl" />
        </div>
        <div className="h-64 bg-slate-200/60 rounded-xl mt-4" />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Suspense fallback={<LoadingSkeleton />}>
          <Routes>
            {PublicRoutes()}
            {AdminRoutes()}
            {OwnerRoutes()}
            {StaffRoutes()}
          </Routes>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
}
